interface AboutOutroSectionTexts {
  strongName?: string;
  p4?: string;
  p5?: string;
  p6?: string;
}

export default function AboutOutroSection({ texts }: { texts?: AboutOutroSectionTexts }) {
  const strongName = texts?.strongName ?? "";
  const p4 = texts?.p4 ?? "";
  const p5 = texts?.p5 ?? "";
  const p6 = texts?.p6 ?? "";

  const renderP5 = () => {
    if (p5.includes(strongName)) {
      const parts = p5.split(strongName);
      return (
        <>
          {parts[0]}
          <strong className="text-primary-600">{strongName}</strong>
          {parts[1]}
        </>
      );
    }
    return <>{p5}</>;
  };

  return (
    <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
          NetBasis International - drive to excellence with excellent drivers !
        </h2>

        <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <p>{p4}</p>
          <p>{renderP5()}</p>
          <p>{p6}</p>
        </div>
      </div>
    </section>
  );
}